import React, { useState } from "react";
import PropTypes from "prop-types";

// components:
import Modal from "core/Modal";
import CircleButton from "core/CircleButton";
import Tooltip from "core/Tooltip";

import ChooseKit from "./ChooseKit";
import CreateKit from "./CreateKit";
import FooterContent from "./FooterContent";

// icons:
import Add from "core/ReusableIcons/Add";
import AddedToList from "core/ReusableIcons/AddedToList";

// mock data:
import { hasKitsAndFavorites } from "./__mocks__/saveToKitsMocks"; // todo: replace with actual response when mutation/query is ready

const SaveToKits = ({
    iconId,
    userHasSubscription = false,
    ownedTeams,
    username
}) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [showChooseKit, setShowChooseKit] = useState(true);
    const [showCreateKit, setShowCreateKit] = useState(false);

    const openModal = e => {
        e.preventDefault();
        setModalOpen(true);
    };

    const closeModal = e => {
        e.preventDefault();
        setModalOpen(false);

        // delay resetting modal screen so user
        // doesnt see it switch while modal is in
        // process of closing:
        setTimeout(() => {
            setShowCreateKit(false);
            setShowChooseKit(true);
        }, 500);
    };

    const handleShowChooseKit = e => {
        e.preventDefault();
        setShowCreateKit(false);
        setShowChooseKit(true);
    };

    const handleShowCreateKit = e => {
        e.preventDefault();
        setShowCreateKit(true);
        setShowChooseKit(false);
    };

    const initialFormData = {
        name_of_kit: "",
        privacy: "",
        owner: "",
        description: ""
    };

    const isSavedToKit = !!hasKitsAndFavorites.find(
        kit => kit.user_owned && kit.icon_ids == iconId
    );

    const modalTriggerText = isSavedToKit ? "Saved to a Kit" : "Add to Kit";
    const modalTriggerIcon = isSavedToKit ? <AddedToList /> : <Add />;

    const modalHeading = showCreateKit ? "Create a New Kit" : "Choose a Kit";

    const footerContent = showChooseKit ? (
        <FooterContent
            isFreeUser={!userHasSubscription}
            handleFooterButtonClick={handleShowCreateKit}
        />
    ) : null;

    return (
        <>
            <Tooltip size="small" message={modalTriggerText}>
                <CircleButton
                    title={modalTriggerText}
                    isToggled={isSavedToKit}
                    icon={modalTriggerIcon}
                    onClick={openModal}
                />
            </Tooltip>

            <Modal
                type="kit"
                open={isModalOpen}
                onClose={closeModal}
                handleClose={closeModal}
                heading={modalHeading}
                footerChildren={footerContent}
            >
                {showChooseKit && !showCreateKit && (
                    <ChooseKit iconId={iconId} kits={hasKitsAndFavorites} />
                )}

                {!showChooseKit && showCreateKit && (
                    <CreateKit
                        initialForm={initialFormData}
                        handleCancelClick={handleShowChooseKit}
                        ownedTeams={ownedTeams}
                        username={username}
                    />
                )}
            </Modal>
        </>
    );
};

SaveToKits.propTypes = {
    iconId: PropTypes.number.isRequired,
    userHasSubscription: PropTypes.bool,
    username: PropTypes.string,
    ownedTeams: PropTypes.arrayOf(
        PropTypes.shape({
            option: PropTypes.string,
            slug: PropTypes.string
        })
    )
};

export default SaveToKits;
